import Swiper, { Navigation, Pagination, Autoplay, EffectFade, FreeMode, Mousewheel} from 'swiper';

document.addEventListener('DOMContentLoaded', function(){

    if(document.querySelector('.jsSliderIntro')){
        let slider = document.querySelector('.jsSliderIntro');
        let attr = slider.getAttribute('data-slider-delay');
        let delay;

        if(attr){
            delay = attr;
        } else{
            delay = 7000;
        }

        const jsSliderIntro = new Swiper('.jsSliderIntro .slider__inner', {
            modules: [Navigation, Pagination, Autoplay, EffectFade],
            pagination: {
                el: '.jsSliderIntro .swiper-pagination',
                bulletClass: 'slider__pagination-item',
                clickable: true,
            },
        
            navigation: {
                nextEl: '.jsSliderIntro .swiper-button-next',
                prevEl: '.jsSliderIntro .swiper-button-prev',
            },
            // autoplay: {delay: delay},
            loop: true,
            effect: 'fade',
            slidesPerView: 1,
            speed: 1000,
            spaceBetween: 45,   
        });

        if(document.querySelector('.jsAnimationElements')){
            const jsAnimationElements = document.querySelector('.jsAnimationElements');
            jsAnimationElements.setAttribute('data-animation', '');
            jsAnimationElements.classList.add('is-animate');
            changeSlide();
        
            jsSliderIntro.on('slideChange', () => {
                changeSlide();
            })
        
            function changeSlide(){
                let slideIndex = jsSliderIntro.realIndex;
                jsAnimationElements.setAttribute('data-animation', slideIndex);
            }
        }
    }
    
    if(document.querySelector('.jsSliderReviews')){
        const jsSliderReviews = new Swiper('.jsSliderReviews .slider__inner', {
            modules: [Navigation, Pagination],
        
            pagination: {
                el: '.jsSliderReviews .swiper-pagination',
                clickable: true,
                bulletClass: 'slider__pagination-item',
            },
        
            navigation: {
                nextEl: '.jsSliderReviews .swiper-button-next',
                prevEl: '.jsSliderReviews .swiper-button-prev',
            },
        
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 16,
            speed: 600,
        
            breakpoints: {
                0:{
                    spaceBetween: 16,
                    slidesPerView: 1,
                },
                576: {
                    spaceBetween: 16,
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
        
                992: {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                },
                
                1100: {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                },
            }
        });
    }    
    
    if(document.querySelector('.jsSliderOffers')){
        const jsSliderOffers = new Swiper('.jsSliderOffers .slider__inner', {
            modules: [Navigation, Pagination, Autoplay],
            pagination: {
                el: '.jsSliderOffers .swiper-pagination',
                bulletClass: 'slider__pagination-item',
                clickable: true,
        
            },
        
            navigation: {
                nextEl: '.jsSliderOffers .swiper-button-next',
                prevEl: '.jsSliderOffers .swiper-button-prev',
            },
        
            loop: true,
            slidesPerView: 1,
            autoHeight: true,
            speed: 600,
            centeredSlides: true,
            spaceBetween: 25,   
        
            breakpoints: {
                0:{
                    pagination: {
                        el: '.jsSliderOffers .swiper-pagination',
                        bulletClass: 'slider__pagination-item',
                        clickable: true,
                
                    },
                },
        
                992: {
                    pagination: {
                        bulletClass: 'slider__fraction-item',
                        renderBullet: function(index){
                            if(index < 9){
                                let thisIndex = index + 1;
                                return '<span class="slider__fraction-item">0' + thisIndex + '</span>'
                            } else{
                                let thisIndex = index + 1;
                                return '<span class="slider__fraction-item">' + thisIndex + '</span>'
                            }
            
                        },
                        bulletActiveClass: 'slider__fraction-item--active',
                    },
                },
            }
        });
    }    

    if(document.querySelector('.jsSliderDiplom')){
        const jsSliderDiplom = new Swiper('.jsSliderDiplom .slider__inner', {
            modules: [Navigation],
        
            navigation: {
                nextEl: '.jsSliderDiplom .swiper-button-next',
                prevEl: '.jsSliderDiplom .swiper-button-prev',
            },
        
            loop: false,
            slidesPerView: 1,
            speed: 600,
            centeredSlides: true,
            spaceBetween: 25,   
        });    
    
        const jsSliderDiplomLink = document.querySelectorAll('.jsSliderDiplomLink');
    
        for (let index = 0; index < jsSliderDiplomLink.length; index++) {
            let item = jsSliderDiplomLink[index];
            let slideIndex = item.getAttribute('data-slide-index');
           
            item.addEventListener('click', (e) => {
                e.preventDefault()
                jsSliderDiplom.slideTo(slideIndex);
            })
    
            jsSliderDiplom.on('slideChange', () => {
                item.classList.remove('is-active')
                jsSliderDiplomLink[jsSliderDiplom.activeIndex].classList.add('is-active')
            })
        }
    } 

    if(document.querySelector('.jsSliderSpecialist')){
        const jsSliderSpecialist = new Swiper('.jsSliderSpecialist .slider__inner', {
            modules: [Navigation, Pagination, Autoplay],
            autoHeight: true,
            pagination: {
                el: '.jsSliderSpecialist .swiper-pagination',
                clickable: true,
                bulletClass: 'slider__pagination-item',
            },
            navigation: {
                nextEl: '.jsSliderSpecialist .swiper-button-next',
                prevEl: '.jsSliderSpecialist .swiper-button-prev',
            },
        
            loop: false,
            grabCursor: true,
            slidesPerView: 1,
            speed: 750,
            spaceBetween: 60,
        });

        const jsSliderSpecialistLink = document.querySelectorAll('.jsSliderSpecialistLink');

        for (let index = 0; index < jsSliderSpecialistLink.length; index++) {
            let item = jsSliderSpecialistLink[index];
            let slideIndex = item.getAttribute('data-slide-index');
           
            item.addEventListener('click', (e) => {
                e.preventDefault()
                jsSliderSpecialist.slideTo(slideIndex);
            })
    
            jsSliderSpecialist.on('slideChange', () => {
                item.classList.remove('is-active')
            })
        }
    
        jsSliderSpecialist.on('slideChange', () => {
            jsSliderSpecialistLink[jsSliderSpecialist.activeIndex].classList.add('is-active')
        })
    }    

    if(document.querySelector('.jsSliderProductDetail')){
        const jsSliderProductDetail = new Swiper('.jsSliderProductDetail .slider__inner', {
            modules: [Navigation, EffectFade, Autoplay],
            loop: true,
            slidesPerView: 1,
            speed: 500,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
    
            navigation: {
                nextEl: '.jsSliderProductDetail .swiper-button-next',
                prevEl: '.jsSliderProductDetail .swiper-button-prev',
            },
        });
    }

    if(document.querySelector('.jsSliderArticleGallery')){
        const jsSliderArticleGallery = document.querySelectorAll('.jsSliderArticleGallery');
        
        for (let index = 0; index < jsSliderArticleGallery.length; index++) {
            let item = jsSliderArticleGallery[index];
            
            const sliderArticleGallery = new Swiper(item.querySelector('.slider__inner'), {
                modules: [Navigation, Pagination, Autoplay],
                pagination: {
                    el: item.querySelector('.swiper-pagination'),
                    clickable: true,
                    bulletClass: 'slider__pagination-item',
                },
                navigation: {
                    nextEl: item.querySelector('.swiper-button-next'),
                    prevEl: item.querySelector('.swiper-button-prev'),
                },
        
                loop: false,
                slidesPerView: 1,
                speed: 750,
                spaceBetween: 32,
            });
        }
    }

    if(document.querySelector('.jsSliderProduct')){
        const jsSliderProduct = document.querySelectorAll('.jsSliderProduct');
        
        for (let index = 0; index < jsSliderProduct.length; index++) {
            let item = jsSliderProduct[index];
            
            const sliderProduct = new Swiper(item.querySelector('.slider__inner'), {
                modules: [ Pagination,  EffectFade],
                loop: true,
                slidesPerView: 1,
                speed: 750,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                
                pagination: {
                    el: item.querySelector('.swiper-pagination'),
                    clickable: true,
                    bulletClass: 'slider__pagination-item',
                },

            });
        }
    }
      
    if (document.querySelector('.jsSliderCooperation')) {
        const jsSliderCooperation = new Swiper('.jsSliderCooperation .slider__inner', {
            modules: [Navigation, Pagination, Autoplay, Mousewheel],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 32,
            speed: 600,
            centeredSlides: true,
            mousewheel: true,

            autoplay: {
                delay: 6000,
            },

            breakpoints: {
                0:{
                    spaceBetween: 32,
                },

                1260: {
                    spaceBetween: 56,
                },
            },
        });
    }

    if (window.screen.width < 992) {
        if(document.querySelector('.jsSliderTeachers')){
            const jsSliderTeachers = new Swiper('.jsSliderTeachers .slider__inner', {
                modules: [Navigation, Pagination, Autoplay],
                pagination: {
                    el: '.jsSliderTeachers .swiper-pagination',
                    bulletClass: 'slider__pagination-item',
                    clickable: true,
                },
                autoHeight: true,
                loop: false,
                slidesPerView: 2,
                speed: 600,
                spaceBetween: 32,   
        
                breakpoints: {
                    0:{
                        spaceBetween: 16,
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 24,   
                    },
                }
            });
        }
    }
})
